var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "animated fadeIn dash-main" },
    [
      _c(
        "b-row",
        [
          _c(
            "b-col",
            { attrs: { md: "12", lg: "4" } },
            [
              _c(
                "router-link",
                { attrs: { to: { path: "/templates" } } },
                [
                  _c(
                    "b-card",
                    { staticClass: "dash-box", attrs: { "no-body": "" } },
                    [
                      _c(
                        "b-card-body",
                        { staticClass: "p-6" },
                        [
                          _c(
                            "b-row",
                            { staticClass: "dash-row" },
                            [
                              _c(
                                "b-col",
                                { staticClass: "pr-0", attrs: { xs: "9" } },
                                [
                                  _c("h1", { staticClass: "mb-0" }, [
                                    _vm._v(_vm._s(_vm.$t("Templates")))
                                  ]),
                                  _vm._v(" "),
                                  _c(
                                    "h4",
                                    [
                                      _c("animated-number", {
                                        attrs: {
                                          value: _vm.totalTemplate || 0,
                                          formatValue: _vm.formatNumber,
                                          duration: 1000
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ]
                              ),
                              _vm._v(" "),
                              _c("b-col", { attrs: { xs: "9" } }, [
                                _c("div", {
                                  domProps: {
                                    innerHTML: _vm._s(_vm.svg.templates)
                                  }
                                })
                              ])
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "b-col",
            { attrs: { md: "12", lg: "8" } },
            [
              _c(
                "router-link",
                { attrs: { to: { path: "/process/processed" } } },
                [
                  _c(
                    "b-card",
                    { staticClass: "dash-box", attrs: { "no-body": "" } },
                    [
                      _c(
                        "b-card-body",
                        { staticClass: "pb-6" },
                        [
                          _c(
                            "b-row",
                            { staticClass: "dash-row" },
                            [
                              _c("b-col", { attrs: { cols: "10" } }, [
                                _c("h1", { staticClass: "mb-0" }, [
                                  _vm._v(_vm._s(_vm.$t("Forms")))
                                ]),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  { staticClass: "process-datas" },
                                  _vm._l(_vm.processForms, function(
                                    count,
                                    processed
                                  ) {
                                    return _c(
                                      "div",
                                      { staticClass: "process-data" },
                                      [
                                        _c(
                                          "h4",
                                          { class: "processed-" + processed },
                                          [
                                            _c("animated-number", {
                                              attrs: {
                                                value: count || 0,
                                                formatValue: _vm.formatNumber,
                                                duration: 1500
                                              }
                                            })
                                          ],
                                          1
                                        ),
                                        _vm._v(" "),
                                        _c("h3", {}, [
                                          _vm._v(
                                            " " +
                                              _vm._s(
                                                _vm.$t(
                                                  "COMMON." +
                                                    processed.toUpperCase()
                                                )
                                              ) +
                                              " "
                                          )
                                        ])
                                      ]
                                    )
                                  })
                                )
                              ]),
                              _vm._v(" "),
                              _c("b-col", { attrs: { cols: "2" } }, [
                                _c("div", {
                                  domProps: { innerHTML: _vm._s(_vm.svg.forms) }
                                })
                              ])
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-row",
        { staticClass: "second-row" },
        _vm._l(_vm.boxes, function(box, index) {
          return box.show
            ? _c(
                "b-col",
                { key: index, attrs: { md: "6", lg: "3" } },
                [
                  _c(
                    "router-link",
                    { attrs: { to: { path: box.path } } },
                    [
                      _c(
                        "b-card",
                        { staticClass: "dash-box", attrs: { "no-body": "" } },
                        [
                          _c(
                            "b-card-body",
                            { staticClass: "pb-6" },
                            [
                              _c(
                                "b-row",
                                { staticClass: "dash-row" },
                                [
                                  _c("b-col", { attrs: { xs: "7" } }, [
                                    _c("h1", { staticClass: "mb-0" }, [
                                      _vm._v(_vm._s(_vm.$t(box.name)))
                                    ])
                                  ]),
                                  _vm._v(" "),
                                  _c("b-col", { attrs: { xs: "5" } }, [
                                    _c("div", {
                                      domProps: {
                                        innerHTML: _vm._s(_vm.svg[box.icon])
                                      }
                                    })
                                  ])
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            : _vm._e()
        })
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-6cdeb2ee", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6cdeb2ee","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/dashboard/main.vue
// module id = 1433
// module chunks = 2